import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { PushResourcePackage } from "../resources/PushResourcePackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";

export class SecondaryRewardContainer extends Container {
    public constructor(rewardValue: number, pushResources: PushResourcePackage, commonResources: CommonResourcesPackage) {
        super();
        const descriptionText = new Text('AND RECEIVE A', new ContainerTextStyle());
        descriptionText.anchor.set(0.5);
        descriptionText.skew.set(0, -0.09);
        this.addChild(descriptionText);
        
        const rewardCountText = new Text(StringFormatExtention.formatWithComma(rewardValue), new RewardCountTextStyle());
        rewardCountText.anchor.set(0.5);
        rewardCountText.position.set(-35, 78);
        this.addChild(rewardCountText);

        const rewardIcon = new Sprite(commonResources.assets_common_ui_top_panel_coin_png);
        rewardIcon.anchor.set(0.5);
        rewardIcon.scale.set(1.06);
        rewardIcon.angle = -6;
        rewardIcon.position.set(131, 73);
        this.addChild(rewardIcon);

        const underline = new Sprite(pushResources.assets_views_push_underline_png);
        underline.anchor.set(0.5);
        underline.position.set(15, 171);
        this.addChild(underline);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#efcb0f",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40
        }));
    }
}

class RewardCountTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 100
        }));
    }
}

